(function () {
  const sections = document.querySelectorAll(".koffi-ugc");
  if (!sections.length) return;

  const prefersReduced =
    window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function clamp(n, min, max) {
    return Math.max(min, Math.min(max, n));
  }

  function readNumberCSSVar(el, name, fallback) {
    const v = (getComputedStyle(el).getPropertyValue(name) || "").trim();
    const n = Number(v);
    return Number.isFinite(n) && n > 0 ? n : fallback;
  }

  function isMobile() {
    return window.matchMedia("(max-width: 989px)").matches;
  }

  function stopAllVideos(root) {
    const vids = root.querySelectorAll("video");
    vids.forEach((v) => {
      try { v.pause(); } catch (e) {}
    });
  }

  sections.forEach((section) => {
    const track = section.querySelector("[data-ugc-track]");
    if (!track) return;

    const cards = Array.from(section.querySelectorAll(".koffi-ugc__card"));
    const openBtns = Array.from(section.querySelectorAll("[data-ugc-open]"));
    const btnPrev = section.querySelector("[data-ugc-prev]");
    const btnNext = section.querySelector("[data-ugc-next]");
    const dotsWrap = section.querySelector("[data-ugc-dots]");

    const enableHoverPlay = section.dataset.autoplayHover === "true";

    // ---- Hover preview (desktop): clone preview video template into the shell ----
    if (enableHoverPlay && !prefersReduced) {
      openBtns.forEach((btn) => {
        const shell = btn.querySelector(".koffi-ugc__videoShell");
        const poster = btn.querySelector(".koffi-ugc__poster");
        const tpl = btn.querySelector("template[data-ugc-preview-template]");
        if (!shell || !tpl) return;

        let previewVideo = null;

        function mount() {
          if (previewVideo) return;
          const frag = tpl.content.cloneNode(true);
          const v = frag.querySelector("video");
          if (!v) return;
          v.classList.add("koffi-ugc__previewLive");
          shell.appendChild(v);
          previewVideo = v;
          if (poster) poster.style.opacity = "0";
        }

        function unmount() {
          if (!previewVideo) return;
          try { previewVideo.pause(); } catch (e) {}
          previewVideo.remove();
          previewVideo = null;
          if (poster) poster.style.opacity = "";
        }

        btn.addEventListener("mouseenter", async () => {
          if (isMobile()) return;
          mount();
          if (!previewVideo) return;
          try { await previewVideo.play(); } catch (e) {}
        });

        btn.addEventListener("mouseleave", unmount);
      });
    }

    // ---- Dots/arrows (page-based, stable) ----
    function getPerView() {
      const desktop = readNumberCSSVar(section, "--koffi-perview", 3);
      const mobile = readNumberCSSVar(section, "--koffi-perview-m", 1);
      return clamp(isMobile() ? mobile : desktop, 1, 6);
    }

    function getStep() {
      const first = cards[0]?.querySelector(".koffi-ugc__media") || cards[0];
      if (!first) return 1;
      const rect = first.getBoundingClientRect();
      const styles = getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || "0") || 0;
      return rect.width + gap;
    }

    let perView = getPerView();
    let step = getStep();
    let pageCount = Math.ceil(cards.length / perView);
    let activePage = 0;
    let dots = [];
    let isProgrammatic = false;
    let settleTimer = null;

    function pageStepPx() {
      return step * perView;
    }

    function pageFromScroll() {
      const ps = pageStepPx() || 1;
      const idx = Math.round(track.scrollLeft / ps);
      return clamp(idx, 0, pageCount - 1);
    }

    function setDots(i) {
      if (!dots.length) return;
      dots.forEach((d, idx) => d.classList.toggle("is-on", idx === i));
    }

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = "";
      dots = [];
      for (let i = 0; i < pageCount; i++) {
        const d = document.createElement("button");
        d.type = "button";
        d.className = "koffi-ugc__dot" + (i === 0 ? " is-on" : "");
        d.setAttribute("aria-label", `Go to videos page ${i + 1}`);
        d.addEventListener("click", () => scrollToPage(i, prefersReduced ? "auto" : "smooth"));
        dotsWrap.appendChild(d);
        dots.push(d);
      }
    }

    function lockDuringScroll() {
      isProgrammatic = true;
      if (settleTimer) window.clearTimeout(settleTimer);
      settleTimer = window.setTimeout(() => {
        isProgrammatic = false;
        const p = pageFromScroll();
        activePage = p;
        setDots(activePage);
      }, prefersReduced ? 0 : 240);
    }

    function scrollToPage(p, behavior) {
      if (pageCount <= 1) return;
      const page = clamp(p, 0, pageCount - 1);
      activePage = page;
      setDots(activePage);
      lockDuringScroll();
      track.scrollTo({ left: pageStepPx() * page, behavior });
    }

    function recalc(keep = true) {
      perView = getPerView();
      step = getStep();
      pageCount = Math.ceil(cards.length / perView);
      buildDots();
      if (!keep) activePage = 0;
      activePage = clamp(activePage, 0, pageCount - 1);
      setDots(activePage);
    }

    if (btnPrev) btnPrev.addEventListener("click", () => scrollToPage(activePage - 1, prefersReduced ? "auto" : "smooth"));
    if (btnNext) btnNext.addEventListener("click", () => scrollToPage((activePage + 1) % pageCount, prefersReduced ? "auto" : "smooth"));

    let raf = null;
    track.addEventListener("scroll", () => {
      if (isProgrammatic) return;
      if (!dotsWrap) return;
      if (raf) return;
      raf = requestAnimationFrame(() => {
        raf = null;
        const p = pageFromScroll();
        if (p !== activePage) {
          activePage = p;
          setDots(activePage);
        }
      });
    }, { passive: true });

    recalc(false);
    scrollToPage(0, "auto");

    let r = null;
    window.addEventListener("resize", () => {
      if (r) return;
      r = requestAnimationFrame(() => {
        r = null;
        const keep = activePage;
        recalc(true);
        scrollToPage(keep, "auto");
      });
    }, { passive: true });

    // ---- Modal cloning (Shopify-native) ----
    const modal = section.querySelector("[data-ugc-modal]");
    const stage = section.querySelector("[data-ugc-modal-stage]");
    const closeBtns = Array.from(section.querySelectorAll("[data-ugc-close]"));

    function openModalFrom(btn) {
      if (!modal || !stage) return;

      stopAllVideos(section);

      const tpl = btn.querySelector("template[data-ugc-template]");
      if (!tpl) return;

      stage.innerHTML = "";
      stage.appendChild(tpl.content.cloneNode(true));

      modal.hidden = false;

      const v = stage.querySelector("video");
      if (v) {
        v.playsInline = true;
        v.autoplay = true;
        v.play().catch(() => {});
      }
    }

    function closeModal() {
      if (!modal || !stage) return;
      stopAllVideos(stage);
      stage.innerHTML = "";
      modal.hidden = true;
    }

    closeBtns.forEach((b) => b.addEventListener("click", closeModal));
    window.addEventListener("keydown", (e) => {
      if (e.key === "Escape") closeModal();
    });

    openBtns.forEach((btn) => btn.addEventListener("click", () => openModalFrom(btn)));
  });
})();
